import React from 'react';
import { Link } from 'react-router-dom';

const Comp = (...arg) => {
    console.log(arg);
    return (
        <div>
            <div>基准线数据管理</div>
        </div>
    );
};

export default Comp;



// WEBPACK FOOTER //
// ./containers/sider/baseline.js